export class Education {
  public id: string;
  public name: string;

  constructor(education: any = undefined) {
    if (education) this.setProperties(education);
  }

  getDatesAttended(): string {
    return '01/01/2011 - 01/01/2012';
  }

  private setProperties(education: any) {
    this.id = education.id;
    this.name = education.name;
  }
}
